var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[(_vm.getBackgroundImage())?_c('div',{staticClass:"app-background",style:({ 'background-image': 'url(' + _vm.getBackgroundImage() + ')' })}):_vm._e(),_c('CardList')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }